'use client';

import { AlertTriangle, CheckCircle } from 'lucide-react';
import { LoadingSpinner } from '@/shared/ui';
import type { ValidationItem } from './types';

interface ValidationItemsListProps {
  items: ValidationItem[];
}

function getStatusIcon(status: ValidationItem['status']) {
  switch (status) {
    case 'validating':
      return <LoadingSpinner className="h-5 w-5" />;
    case 'valid':
      return <CheckCircle className="h-5 w-5 text-primary" />;
    case 'invalid':
    case 'error':
      return <AlertTriangle className="h-5 w-5 text-destructive" />;
  }
}

export function ValidationItemsList({ items }: ValidationItemsListProps) {
  return (
    <div className="space-y-3 flex-1 overflow-y-auto mb-4">
      {items.map((item) => (
        <div key={item.id} className="flex items-start space-x-3">
          <div className="flex-shrink-0 mt-0.5">
            {getStatusIcon(item.status)}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-list-item-value truncate">{item.fileName}</p>
            {(item.status === 'invalid' || item.status === 'error') &&
              item.error && (
                <p className="text-form-error text-destructive mt-1">{item.error}</p>
              )}
          </div>
        </div>
      ))}
    </div>
  );
}
